<div class="register-page-container" *ngIf="!isLabelsLoading && !isLoadingPermissions">
	<!-- HEADER SECTION -->
	<div class="header">
		<div class="title">
			<span>{{ labels.lbl_geral_cadastro || 'Cadastro' }}</span>
		</div>
		<div class="header-actions" *ngIf="ProfileService.userData().usertype === 'analyst.manager.administrator'">
			<div class="button-container-row">
				<div class="evaluation-button" (click)="openModalEvaluationMSP()">{{ labels.lbl_geral_avaliar }} MySupport</div>
				<cpi-checkbox
					[forceText]="false"
					[value]="seeHiddenOptions"
					(oValue)="
						seeHiddenOptions = $event;
						checkParentOptionsPermissions();
						setSelectedOption(selectedParentOption || parentOptions[0], undefined)
					"
					[innerText]="labels.lbl_mostrar_opcoes_escondidas">
				</cpi-checkbox>
			</div>
		</div>
	</div>

	<msp-breadcrumb-navigation [breadcrumb]="getBreadcrumbs()"> </msp-breadcrumb-navigation>

	<div class="cmdb-register-container">
		<div class="folder-container">
			<!-- Parent Category Tabs -->
			<div class="tabs-container">
				<div class="tabs-list">
					<ng-container *ngFor="let parentOption of parentOptions">
						<span
							class="tab"
							[ngClass]="{
								selected: selectedParentOption?.id === parentOption.id,
								'show-hidden': parentOption.hidden && seeHiddenOptions,
							}"
							(click)="setSelectedOption(parentOption, undefined)"
							*ngIf="!parentOption.hidden || seeHiddenOptions">
							<fa-icon
								[icon]="icons[parentOption.icon] ? icons[parentOption.icon] : icons.faAddressCard"
								class="tab-icon"></fa-icon>
							{{ labels[parentOption.label] ? labels[parentOption.label] : parentOption.name }}
						</span>
					</ng-container>
				</div>
			</div>

			<!-- Tab Content Area -->
			<div class="tab-content-container visible">
				<!-- Grid of Child Option Cards (shown when no child option is selected) -->
				<div *ngIf="selectedChildOption === undefined" class="options-grid-container">
					<div class="section-header">
						<h3 class="section-subtitle">{{ labels[selectedParentOption?.label] || selectedParentOption?.name }}</h3>
						<span class="description-text">{{
							labels.lbl_selecione_para_continuar ||
								'Selecione uma opção
							para continuar'
						}}</span>
					</div>

					<div class="checkbox-grid">
						<ng-container *ngFor="let childOption of this[selectedParentOption?.id + 'ChildOptions']">
							<div
								class="checkbox-card option-card"
								[ngClass]="{ 'show-hidden': childOption.hidden && seeHiddenOptions }"
								(click)="
									childOption.hidden && seeHiddenOptions
										? showRequiredPermissions(selectedParentOption.id, childOption.id)
										: setSelectedOption(selectedParentOption, childOption)
								"
								*ngIf="!childOption.hidden || seeHiddenOptions">
								<div class="card-content">
									<div class="card-icon-wrapper">
										<fa-icon [icon]="getChildOptionIcon(childOption.id)" class="card-icon"></fa-icon>
									</div>
									<div class="card-text-wrapper">
										<span class="label-text">{{
											labels[childOption.label] ? labels[childOption.label] : childOption.name
										}}</span>
										<span class="card-description">{{ getChildOptionDescription(childOption.id) }}</span>
									</div>
									<div class="card-arrow">
										<fa-icon [icon]="icons.faAngleRight"></fa-icon>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>

				<!-- Selected Form Container -->
				<div *ngIf="selectedChildOption !== undefined" class="form-wrapper">
					<!-- Back button / Form header -->
					<div class="form-header">
						<button class="back-button" (click)="setSelectedOption(selectedParentOption, undefined)">
							<fa-icon [icon]="icons.faAngleRight" class="back-icon"></fa-icon>
							{{ labels.lbl_geral_voltar || 'Voltar para' }}
							{{ labels[selectedParentOption?.label] || selectedParentOption?.name }}
						</button>
						<h2 class="form-title">
							{{ labels[selectedChildOption.label] ? labels[selectedChildOption.label] : selectedChildOption.name }}
						</h2>
					</div>

					<div class="form-body">
						<ng-container [ngSwitch]="selectedChildOption.id">
							<register-form-stylesheet *ngSwitchCase="'stylesheet'"></register-form-stylesheet>

							<!-- Grouped Locality and Site Container! -->
							<div *ngSwitchCase="'localitiesSites'" class="sub-tabs-form-container">
								<div class="sub-tabs-container">
									<span
										class="sub-tab"
										[ngClass]="{ selected: subTab === 'locality' }"
										(click)="subTab = 'locality'"
										*ngIf="PermissionService.hasPermissions('register_locality') || seeHiddenOptions">
										{{ labels.lbl_geral_localidades || 'Localidades' }}
									</span>
									<span
										class="sub-tab"
										[ngClass]="{ selected: subTab === 'sites' }"
										(click)="subTab = 'sites'"
										*ngIf="PermissionService.hasPermissions('register_sites') || seeHiddenOptions">
										{{ labels.lbl_geral_sites || 'Sites' }}
									</span>
								</div>
								<div class="sub-tab-content">
									<register-form-locality *ngIf="subTab === 'locality'"></register-form-locality>
									<register-form-site *ngIf="subTab === 'sites'"></register-form-site>
								</div>
							</div>
							<!-- 
							<register-form-locality *ngSwitchCase="'locality'"></register-form-locality>

							<register-form-site *ngSwitchCase="'sites'"></register-form-site> -->

							<register-form-classification *ngSwitchCase="'servicetype'"></register-form-classification>

							<register-form-cmdb-alert *ngSwitchCase="'cmdbAlert'"></register-form-cmdb-alert>

							<register-form-cmdb-load *ngSwitchCase="'cmdbLoad'"></register-form-cmdb-load>

							<register-form-ci-field *ngSwitchCase="'cmdbCiField'"></register-form-ci-field>

							<!-- Grouped Manufacturer and Model Container! -->
							<div *ngSwitchCase="'manufacturersModels'" class="sub-tabs-form-container">
								<div class="sub-tabs-container">
									<span
										class="sub-tab"
										[ngClass]="{ selected: subTab === 'manufacturer' }"
										(click)="subTab = 'manufacturer'"
										*ngIf="PermissionService.hasPermissions('register_fabricantes') || seeHiddenOptions">
										{{ labels.lbl_asset_fabricante || 'Fabricantes' }}
									</span>
									<span
										class="sub-tab"
										[ngClass]="{ selected: subTab === 'model' }"
										(click)="subTab = 'model'"
										*ngIf="PermissionService.hasPermissions('register_modelo') || seeHiddenOptions">
										{{ labels.lbl_geral_modelo || 'Modelos' }}
									</span>
								</div>
								<div class="sub-tab-content">
									<register-form-manufacturer *ngIf="subTab === 'manufacturer'"></register-form-manufacturer>
									<register-form-model *ngIf="subTab === 'model'"></register-form-model>
								</div>
							</div>

							<register-form-operational-system *ngSwitchCase="'cmdbOperationalSystem'"></register-form-operational-system>

							<app-my-asset-configuration-general *ngSwitchCase="'myAssetConfig'"></app-my-asset-configuration-general>

							<register-form-cpu-model *ngSwitchCase="'cmdbCpuModel'"></register-form-cpu-model>

							<register-form-active-directory *ngSwitchCase="'cmdbAd'"></register-form-active-directory>

							<register-form-access-settings *ngSwitchCase="'accessPermissionSettings'"></register-form-access-settings>

							<register-form-groups-users *ngSwitchCase="'groupsUsers'"></register-form-groups-users>

							<register-form-users *ngSwitchCase="'users'"></register-form-users>

							<register-form-department *ngSwitchCase="'department'"></register-form-department>

							<register-form-custom-labels *ngSwitchCase="'customLabels'"></register-form-custom-labels>

							<register-form-tool-sso *ngSwitchCase="'sso'"></register-form-tool-sso>

							<register-form-custom-preset-columns-report
								*ngSwitchCase="'customPresetColumnsReport'"></register-form-custom-preset-columns-report>

							<register-form-request-field-filters *ngSwitchCase="'callFieldFilter'"></register-form-request-field-filters>

							<register-form-customer-strike *ngSwitchCase="'customerStrike'"></register-form-customer-strike>

							<register-form-custom-emails *ngSwitchCase="'customEmails'"></register-form-custom-emails>

							<register-form-custom-status *ngSwitchCase="'customStatus'"></register-form-custom-status>

							<register-form-service-catalog *ngSwitchCase="'selfserviceCatalog'"></register-form-service-catalog>

							<register-form-request-opening-template
								*ngSwitchCase="'requestOpeningTemplate'"></register-form-request-opening-template>

							<register-form-custom-accordion *ngSwitchCase="'customAccordion'"></register-form-custom-accordion>

							<register-form-customer-information *ngSwitchCase="'customer'"></register-form-customer-information>

							<register-form-task-expiration *ngSwitchCase="'taskExpiration'"></register-form-task-expiration>

							<!-- Grouped Status and Substatus Container! -->
							<div *ngSwitchCase="'statusSubstatus'" class="sub-tabs-form-container">
								<div class="sub-tabs-container">
									<span
										class="sub-tab"
										[ngClass]="{ selected: subTab === 'status' }"
										(click)="subTab = 'status'"
										*ngIf="PermissionService.hasPermissions('register_status') || seeHiddenOptions">
										{{ labels.lbl_geral_status || 'Status' }}
									</span>
									<span
										class="sub-tab"
										[ngClass]="{ selected: subTab === 'substatus' }"
										(click)="subTab = 'substatus'"
										*ngIf="PermissionService.hasPermissions('register_substatus') || seeHiddenOptions">
										{{ labels.lbl_geral_substatus || 'Substatus' }}
									</span>
								</div>
								<div class="sub-tab-content">
									<register-form-status-ci-type *ngIf="subTab === 'status'"></register-form-status-ci-type>
									<register-form-substatus *ngIf="subTab === 'substatus'"></register-form-substatus>
								</div>
							</div>

							<register-form-approvers-group *ngSwitchCase="'approversGroup'"></register-form-approvers-group>

							<app-knowledge-management-tags *ngSwitchCase="'tags'"></app-knowledge-management-tags>

							<register-form-custom-satisfaction-request
								*ngSwitchCase="'customSatisfactionRequest'"></register-form-custom-satisfaction-request>

							<register-form-impact-matrix *ngSwitchCase="'impactMatrix'"></register-form-impact-matrix>

							<register-form-request-customfield *ngSwitchCase="'customFields'"></register-form-request-customfield>

							<register-form-request-customfield-order
								*ngSwitchCase="'customFieldsOrder'"></register-form-request-customfield-order>

							<app-admin-password-reset *ngSwitchCase="'adminPasswordReset'"></app-admin-password-reset>

							<register-form-task-management *ngSwitchCase="'taskManagement'"></register-form-task-management>

							<register-form-sla-management *ngSwitchCase="'slaManagement'"></register-form-sla-management>

							<register-impactXurgencyXseverity *ngSwitchCase="'ImpactUrgencySeverity'"></register-impactXurgencyXseverity>

							<register-form-task-custom-field *ngSwitchCase="'taskCustomField'"></register-form-task-custom-field>

							<register-notification-management *ngSwitchCase="'notificationManagement'"></register-notification-management>

							<register-form-group-manager-analysts
								*ngSwitchCase="'groupManagerAnalysts'"></register-form-group-manager-analysts>

							<app-request-categorization *ngSwitchCase="'requestCategorization'"></app-request-categorization>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="evaluation-msp-modal" id="modalClose" (click)="modalClose($event, false)" *ngIf="isOpenModalEvaluationMSP">
	<div class="evaluation-msp-modal-content">
		<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"><fa-icon [icon]="icons.faXmark"></fa-icon></span>
		<app-mysupport-evaluation></app-mysupport-evaluation>
	</div>
</div>

<div class="loading-container" *ngIf="isLabelsLoading || isLoadingPermissions">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
